import type { JiraIssue, ImplementationIssue } from '@/api/types'

const daysSince = (dateStr: string): number => {
  const today = new Date()
  return Math.floor((today.getTime() - new Date(dateStr).getTime()) / 86400000)
}

const isTemplate = (issue: { summary: string; key: string }): boolean =>
  /template/i.test(issue.summary) || /template/i.test(issue.key)

export function transformIssues(jiraIssues: JiraIssue[]): ImplementationIssue[] {
  return jiraIssues
    .map((issue) => {
      const days = issue.fields.created ? daysSince(issue.fields.created) : 0
      const ragRaw = issue.fields.customfield_10088?.value
      return {
        key: issue.key,
        summary: issue.fields.summary,
        status: issue.fields.status?.name || 'Unknown',
        shortStatus: issue.fields.shortStatus ?? null,
        assignee: issue.fields.assignee?.displayName || null,
        priority: issue.fields.priority?.name || null,
        created: issue.fields.created?.split('T')[0] || null,
        dueDate: issue.fields.duedate || null,
        days,
        activeDays: issue.activeDays ?? days,
        waitingDays: issue.waitingDays ?? 0,
        size: issue.fields.projectSize ?? null,
        handoverDate: issue.handoverDate ?? null,
        rag: (ragRaw === 'Red' || ragRaw === 'Amber' || ragRaw === 'Green') ? (ragRaw as 'Red' | 'Amber' | 'Green') : null,
        jiraTimeSpent: issue.fields.timespent ?? null,
        deliveryDays: issue.deliveryDays ?? 0,
      }
    })
    .filter((issue) => !isTemplate(issue))
}
